
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.64 36.057v7.107H1.466A1.47 1.47 0 000 44.63v2.93c0 .806.66 1.465 1.465 1.465H9.57a2.938 2.938 0 002.93-2.93V36.057h4c.735 0 1.16-.902.676-1.502l-6.92-8.577a.865.865 0 00-1.362-.01l-6.897 8.548c-.522.576-.135 1.541.644 1.541h4zM21.094 11.393V47.56c0 .805.66 1.464 1.465 1.464h2.93a1.47 1.47 0 001.464-1.464V11.393h4c.78 0 1.166-.965.644-1.542L24.7 1.303a.865.865 0 00-1.362.011l-6.92 8.577c-.485.6-.06 1.502.676 1.502h4zM35.547 28.244v17.85a2.938 2.938 0 002.93 2.93h8.105a1.47 1.47 0 001.465-1.466v-2.93a1.47 1.47 0 00-1.465-1.464h-5.176v-14.92h4c.78 0 1.166-.965.644-1.541l-6.897-8.549a.865.865 0 00-1.362.011l-6.92 8.577c-.485.6-.059 1.502.677 1.502h3.999z"}})])
          )
        }
      }
    